import { render, staticRenderFns } from "./RepairRegistrationSelect.vue?vue&type=template&id=7c050631&scoped=true"
import script from "./RepairRegistrationSelect.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c050631",
  null
  
)

export default component.exports